import t from 'react-translate';
import { css } from '@emotion/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { primary } from 'styles/global_defaults/colors';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';
import ExpertMentoringGuides from './expert-mentoring-guides';
import ActionItemsInfo from './action-items-info';
import MenteeLens from './mentee-lens';

const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;

  a {
    color: ${primary};
  }
`;

const Guidance = () => {
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE;
  const { hasAiComponentGeneration } = useSelector(getCurrentInstitution) || {};

  return (
    <div css={styles} className='mx-auto'>
      <div className='title heading-2 mb-2'>{translationBase.TITLE()}</div>
      <div className='text-body black mb-6'>
        {translationBase.DESCRIPTION()}
      </div>
      <ExpertMentoringGuides />
      <ActionItemsInfo />
      {hasAiComponentGeneration && <MenteeLens />}
    </div>
  );
};

export default Guidance;
